<template>
  <Login>
    <template v-slot:title>
      <span id="loginTitle">{{ $t("ResetPassword") }}</span>
    </template>
    <template v-slot:form>
      <form class="loginForm" @submit.prevent="submit">
        <div class="main-login-form-container">
          <div class="password-div">
            <span class="login-input-label">{{ $t('NewPassword') }}</span>
            <input
              v-model="password"
              ref="password"
              type="password"
              name="password"
              class="loginInput userInput effect-7"
              spellcheck="false"
              @keyup.enter="PasswordRecoverySubmit"
              :class="{ fieldErrorInput: badPassword || badLength }"
            />
          </div>
          <div class="password-div">
            <span class="login-input-label">{{ $t('ConfirmNewPassword') }}</span>
            <input
              v-model="confirmPassword"
              ref="confirmPassword"
              type="password"
              name="confirmPassword"
              class="loginInput userInput effect-7"
              spellcheck="false"
              @keyup.enter="PasswordRecoverySubmit"
              :class="{ fieldErrorInput: badPassword || badLength }"
            />
          </div>
        </div>
        <div class="field-error-div">
          <span v-if="badPassword">
            {{ $t("PasswordsDontMatch") }}
          </span>
          <span v-if="badLength">
            {{ $t("PasswordLength") }}
          </span>
        </div>
      </form>
    </template>
    <template v-slot:button>
      <v-btn
        type="submit"
        color="accent--text"
        @click="PasswordRecoverySubmit"
        class="signInInput"
        outlined
        :disabled="!passwordIsValid"
      >
        {{ $t("Send") }}
      </v-btn>
    </template>
  </Login>
</template>

<script>
import _ from "lodash";
import Login from "@/views/Login";
import { mapActions } from "vuex";

export default {
  name: "LoginPasswordRecovery",

  components: { Login },

  data() {
    return {
      /**
       * Stores the password values
       */
      password: "",
      confirmPassword: "",
      badPassword: null,
      badLength: null,
      email: this.$route.params.email,
      token: this.$route.params.bearer,
    };
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this._keyListener);
  },

  computed: {
    passwordIsValid() {
      return this.password === this.confirmPassword &&
        this.password !== "" &&
        this.confirmPassword !== "" &&
        this.password.length >= 8
    }
  },
  methods: {
    ...mapActions(["RESET_PASSWORD"]),

    PasswordRecoverySubmit() {
      if (this.passwordIsValid) {
        const passwordData = {
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.confirmPassword,
        };
        this.RESET_PASSWORD(passwordData)
          .then(
            this.$router.push({ name: "login" }),
            this.$toasted.global.toast_success(this.$t("PasswordReset"))
          )
          .catch((error) => {
            this.$toasted.global.toast_error(error);
          });
        this.badLength = false
        return (this.badPassword = false);
      } else if (this.password.length < 8) {
        return (this.badLength = true)
      }
      else if (this.password !== this.confirmPassword) {
        return (this.badPassword = true);
      }
    },
  },
};
</script>
<style scoped>

.headerContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginPasswordRecovery.vue